
    <ng-progress id="appProgress" [thick]="true" [spinner]="false" [color]="'#4350a3'"></ng-progress>
    <app-icon-definitions></app-icon-definitions>
    <div ui-view></div>
  